{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Shtesa e Chrome nuk është instaluar.",
      "CTA": "Instalo shtesën"
    },
    "TABS": {
      "PHONE": "Telefoni",
      "SMS": "SMS",
      "HISTORY": "Historia"
    },
    "HISTORY": {
      "OPEN": "Hapur",
      "RECENT": "Fundit",
      "MISSED": "Humbur",
      "LOADING": "Duke ngarkuar thirrjet...",
      "EMPTY": "Nuk ka thirrje këtu",
      "ERROR": "Thirrjet nuk u ngarkuan dot",
      "CALL": "Telefono përsëri",
      "CALL_STATUS": {
        "BUTTON": "Vendos statusin e thirrjes",
        "TITLE": "Statusi i thirrjes",
        "SEARCH_PLACEHOLDER": "Kërko statuse...",
        "LOADING": "Duke ngarkuar statuset...",
        "NO_OPTIONS": "Nuk është konfiguruar asnjë status thirrjeje",
        "NO_MATCH": "Asnjë status nuk përputhet",
        "OPTIONS_ERROR": "Statuset nuk u ngarkuan dot",
        "RETRY": "Provo përsëri",
        "CONFIRM_QUESTION": "Të vendoset «{status}» dhe të zgjidhet biseda?",
        "CONFIRM": "Konfirmo",
        "BACK": "Prapa",
        "CANCEL": "Anulo",
        "SAVING": "Duke ruajtur...",
        "SAVE_ERROR": "Statusi nuk u ruajt dot",
        "RESOLVE_ERROR": "Statusi u ruajt, por biseda nuk u zgjidh dot"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Numri i telefonit, p.sh. +421903000000",
      "BODY_PLACEHOLDER": "Shkruani mesazhin tuaj...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Dërgo SMS",
      "SENDING": "Duke dërguar...",
      "SENT": "SMS-ja u dërgua",
      "LOADING": "Po ngarkohen kutitë hyrëse SMS...",
      "NO_INBOX": "Kjo llogari nuk ka kuti hyrëse SMS, prandaj SMS-ja nuk mund të dërgohet.",
      "INVALID_NUMBER": "Shkruani numrin në formatin ndërkombëtar, përfshirë + në fillim.",
      "ERROR": "SMS-ja nuk mund të dërgohej. Ju lutemi provoni përsëri."
    },
    "ACTIONS": {
      "CONNECT": "Lidhu",
      "GO_TO_TAB": "Shko te ajo skedë",
      "DISCONNECT": "Shkëputu",
      "ANSWER": "Përgjigju",
      "HANGUP": "Mbyll thirrjen",
      "HOLD": "Vër në pritje",
      "MUTE": "Heshto mikrofonin",
      "SILENCE": "Heshto zërin",
      "TRANSFER": "Transfero",
      "COMPLETE_TRANSFER": "Përfundo transferimin",
      "RETURN_TO_CALLER": "Kthehu te telefonuesi",
      "CANCEL_TRANSFER": "Anulo transferimin",
      "DIALPAD": "Shfaq tastierën",
      "OPEN_CONVERSATION": "Hap bisedën"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Thirrje hyrëse",
      "INCOMING_CALL_FROM": "Thirrje hyrëse nga {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Thirrje hyrëse nga {number}",
      "ANSWER": "Përgjigju",
      "DECLINE": "Refuzo"
    },
    "TRANSFER": {
      "TITLE": "Transferimi i thirrjes",
      "PLACEHOLDER": "Shkruani numrin për transferim...",
      "SEARCH_PLACEHOLDER": "Kërko agjentë...",
      "TARGET_PLACEHOLDER": "Destinacioni i zgjedhur për transferim",
      "CONFIRM": "Transfero",
      "MODE_DIRECT": "Transfero tani",
      "MODE_CONSULT": "Telefono agjentin fillimisht",
      "CANCEL": "Anulo"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Jeni i sigurt që doni të dilni në pushim për të gjitha radhët?",
      "CONFIRM_READY": "Jeni i sigurt që doni të riktheheni në statusin gati për të gjitha radhët?",
      "CONFIRM_BREAK_QUEUE": "Jeni i sigurt që doni të dilni nga radha {queue}?",
      "CONFIRM_READY_QUEUE": "Jeni i sigurt që doni të hyni në radhën {queue}?",
      "LOGIN_TO_QUEUE": "Hyr",
      "LOGOUT_FROM_QUEUE": "Dil",
      "LOGIN_TO_ALL_QUEUES": "Hyr në të gjitha radhët",
      "LOGOUT_FROM_ALL_QUEUES": "Dil nga të gjitha radhët",
      "OPTION_LOGOUT": "Dil",
      "OPTION_BREAK": "Pushim",
      "OPTION_LUNCH": "Drekë",
      "OPTION_AWAY": "Larg",
      "OPTION_DO_NOT_DISTURB": "Mos shqetëso",
      "OPTION_BUSINESS_TRIP": "Udhëtim pune",
      "CONFIRM": "Konfirmo",
      "CANCEL": "Anulo"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Nuk ka lidhje me sistemin telefonik",
      "MESSAGE": "Duket se lidhja juaj në internet nuk funksionon. Kontrollojeni dhe provoni përsëri.",
      "CREDENTIALS_TITLE": "Sistemi telefonik refuzoi kredencialet tuaja",
      "CREDENTIALS_MESSAGE": "Sistemi telefonik refuzoi emrin e përdoruesit ose fjalëkalimin e ruajtur në profilin tuaj. Kontrollojini te Cilësimet e profilit, ose pyesni administratorin tuaj.",
      "CONFIGURATION_TITLE": "Cilësimet e telefonit nuk janë të vlefshme",
      "CONFIGURATION_MESSAGE": "Emri i përdoruesit SIP ose adresa e serverit nuk është në format të vlefshëm, prandaj telefoni nuk mund të lidhet. Rregullojeni te Cilësimet e profilit.",
      "NETWORK_SHORT": "Lidhja dështoi",
      "CREDENTIALS_SHORT": "Kredencialet u refuzuan",
      "CONFIGURATION_SHORT": "Cilësime telefoni të pavlefshme",
      "RETRY": "Provo përsëri",
      "DISMISS": "Anulo"
    },
    "CONNECTION_QUALITY": "Cilësia e lidhjes",
    "CONNECTION_QUALITY_EXCELLENT": "Shkëlqyer",
    "CONNECTION_QUALITY_GOOD": "Mirë",
    "CONNECTION_QUALITY_FAIR": "Mesatare",
    "CONNECTION_QUALITY_POOR": "Dobët",
    "CONNECTION_QUALITY_DISCONNECTED": "E shkëputur",
    "STATUS": {
      "OFFLINE": "Telefoni jashtë linje",
      "IN_OTHER_TAB": "Telefoni është i lidhur në një skedë tjetër",
      "CONNECTING": "Duke u lidhur...",
      "DISCONNECTING": "Duke u shkëputur...",
      "ONLINE": "Telefoni në linjë",
      "DIALING": "Duke telefonuar",
      "TRANSFERRING": "Duke transferuar...",
      "CONSULTING": "Në bisedë me agjentin",
      "CALLER_ON_HOLD": "Telefonuesi është në pritje",
      "BUSY": "I zënë",
      "DND": "DND",
      "UNAVAILABLE": "I padisponueshëm",
      "REJECTED": "Thirrja u refuzua",
      "CALL_FAILED": "Thirrja dështoi"
    },
    "QUEUES": {
      "MORE": "Radhë të tjera"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Duke telefonuar {number}… Mund ta mbyllni këtë skedë.",
    "NO_NUMBER": "Nuk u dha asnjë numër. Përdorni ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Shkruani numrin e telefonit...",
    "ACTIONS": {
      "DIAL": "Telefono numrin",
      "DIAL_FROM": "Zgjidh numrin nga i cili telefonon"
    },
    "DIAL_FROM": {
      "TITLE": "Telefono nga numri i kutisë hyrëse"
    },
    "VALIDATION": {
      "REQUIRED": "Numri i telefonit është i detyrueshëm",
      "INVALID_FORMAT": "Format i pavlefshëm i numrit të telefonit"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Cilësimet dhe testimi i audios",
    "SELECT_DEVICE": "Zgjidhni pajisjen...",
    "SYSTEM_DEFAULT": "Parazgjedhja e sistemit",
    "SAVED": "U ruajt",
    "DISCONNECTED_SUFFIX": "e shkëputur",
    "DEVICE_DISCONNECTED": "Pajisja e zgjedhur nuk është e lidhur. Telefonatat përdorin parazgjedhjen e sistemit derisa të rikthehet.",
    "MICROPHONE": {
      "TITLE": "Mikrofoni",
      "START_TEST": "Testo mikrofonin",
      "STOP_TEST": "Ndalo testin",
      "LEVEL": "Niveli:",
      "VERDICT": {
        "LISTENING": "Thoni diçka në mikrofon…",
        "SILENT": "Nuk dëgjoheni. Kontrolloni që mikrofoni është i ndezur dhe është zgjedhur ai i duhuri.",
        "LOW": "Dëgjoheni vetëm ulët. Zgjidhni një mikrofon tjetër ose rregulloni volumin hyrës te cilësimet e sistemit.",
        "GOOD": "Zë i mirë — dëgjoheni mirë."
      }
    },
    "SPEAKER": {
      "TITLE": "Altoparlanti",
      "TEST": "Testo altoparlantin",
      "TESTING": "Duke testuar...",
      "VOLUME": "Volumi:",
      "USING_DEFAULT": "Dalja e zgjedhur nuk është e disponueshme — u luajt në parazgjedhjen e sistemit."
    },
    "DONE": "U krye",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Gabim gjatë qasjes në mikrofon. Ju lutemi kontrolloni lejet.",
      "MICROPHONE_PERMISSION_DENIED": "Qasja në mikrofon është e bllokuar. Lejojeni atë te cilësimet e sajtit në shfletuesin tuaj për të përdorur telefonin.",
      "MICROPHONE_SILENT": "Mikrofoni juaj nuk po kap asnjë zë. Kontrolloni cilësimet e audios.",
      "EXTENSION_REQUIRED": "Shtesa e telefonit nuk u gjet. Ju lutemi instalojeni ose aktivizojeni për të përdorur mikrofonin.",
      "SPEAKER_TEST": "Gabim gjatë testimit të altoparlantit."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Jashtë linje",
    "ONLINE": "Në linjë",
    "BUSY": "I zënë"
  },
  "QUEUE_STATUS": {
    "READY": "Gati",
    "NOT_READY": "Nuk pranon thirrje",
    "WRAP_UP": "Përmbyllje",
    "BREAK": "Pushim",
    "LUNCH": "Drekë",
    "AWAY": "Larg",
    "DO_NOT_DISTURB": "Mos shqetëso",
    "BUSINESS_TRIP": "Udhëtim pune",
    "OTHER_CALL": "Thirrje tjetër",
    "QUEUE_CALL": "Thirrje nga radha",
    "OFFLINE": "Jashtë linje",
    "ONLINE": "Në linjë",
    "NO_ACCESS": "Pa telefon",
    "PARTIALLY_READY": "Pjesërisht gati",
    "MIXED": "Të përziera",
    "CHAT_ONLINE": "Në linjë (bisedë)",
    "CHAT_BUSY": "I zënë (bisedë)",
    "CHAT_OFFLINE": "Jashtë linje (bisedë)"
  }
}
